import * as React from 'react';

const NewWindowSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 3h13v15H7.7l5.8-5.8V16h1v-5.5H9v1h3.9L7 17.4V3zM6 19h15V2H6v17z"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M3 12v10h9v-1H4v-9z" />
    </svg>
);

NewWindowSvg.displayName = 'NewWindowSvg';
export default NewWindowSvg;
